module.exports = __webpack_public_path__ + "img/series_09.83c97a83.png";